import React, { useState, useEffect } from "react";
import Help from "@material-ui/icons/Help";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Moment from "react-moment";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { BreadcrumbPage } from "../../shared";
import { CommonCss } from "../../services/CommonCss";
import { getRequest, putRequest, deleteRequest, postRequest } from "../../services/ApiServices";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import clsx from "clsx";
import Confirmation from "../../shared/alerts/Confirmation";
import { LOADING } from "../../action/index";
import { useSelector, useDispatch } from 'react-redux';
import Type from '../Helpsection_images/Type.jpg';
import Searchbutton from '../Helpsection_images/Searchbutton.jpg';
import Clearbutton from '../Helpsection_images/Clearbutton.jpg';
import AddDomain from '../Helpsection_images/AddDomain.jpg';
import { ThemeProvider } from "@mui/styles";
import MUIDataTable from "mui-datatables";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
const getMuiTheme = () => createTheme({

  overrides: {
    MUIDataTableHeadCell: {
      root: {
        textTransform: "none"
      }
    },
    components: {
      MUIDataTableToolbar: {
        styleOverrides: {
          filterPaper: {
            width: "500px",
          }
        }
      }
    },
  }
})

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  tableBody: {
    "& .tss-10rusft-MUIDataTableToolbar-icon": {
      color: "#FF4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
      color: "#FF4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
      justifyContent: "left",
      position: "absolute",
    },
    "& .tss-1ufdzki-MUIDataTableSearch-main": {
      marginRight: "10px",
      width: 500
    },
    "& .tss-1fz5efq-MUIDataTableToolbar-left ": {
      position: "absolute",
      right: 20
    }
  },
  text: {
    paddingLeft: 20
  },
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "0px 0px 2px 1px rgb(0 0 0 / 12%)",
    borderRadius: 8,
  },
  tableLayout: {
    border: 0,
    boxShadow: "0 0 0 0 !important",
  },
  txtInput: {
    "& input": {
      padding: "4px 8px",
      fontWeight: 600,
    },
    "& fieldset": {},
  },
  breadcrumbBox: {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  btnStyle1: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
  link: {
    textTransform: "capitalize",
    //color: "#ff4717 ",
    fontSize: "20px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    '&:hover': {
      "text-decoration": "underline",
      cursor: "pointer",
      background: "none",
      color: "#ff4717"
    }

  },
}));


function Row(props) {
  const { row, editUserDetails } = props;
  const classesCommonCss = CommonCss();
  return (
    <React.Fragment>
      <TableRow>
        <TableCell>{row.domainName}</TableCell>
        <TableCell>{row.date_Added ? <Moment format="DD/MM/YYYY">{row.date_Added}</Moment> : ""}</TableCell>
        <TableCell>{row.added_By}</TableCell>
        {/* <TableCell>{row.lasT_MODIFIED_DATE ? <Moment format="DD MMM YYYY">{row.lasT_MODIFIED_DATE}</Moment> : ""}</TableCell>
        <TableCell>{row.MODIFIED_BY ? <Moment format="DD MMM YYYY">{row.lasT_MODIFIED_DATE}</Moment> : ""}</TableCell> */}
        <TableCell className={classesCommonCss.cursorPointer} onClick={() => { editUserDetails(row) }}>{"Edit"}</TableCell>
        <TableCell>{row.status}</TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    username: PropTypes.string.isRequired,
  }).isRequired,
};

export default function Blocklistdomain() {
  const classes = useStyles();
  const history = useHistory();
  const classesCommonCss = CommonCss();
  const dispatch = useDispatch();
  const BreadcrumbList = [{ name: "BlackListed Domains", url: "" }];
  const [scroll, setScroll] = React.useState('paper');
  const [registeredUsers, setRegisteredUsers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loadedRegisteredUsers, setLoadedRegisteredUsers] = useState([]);

  const [openform, setOpenform] = React.useState(false);
  const handleClickOpenForm = () => {
    setOpenform(true);
  };
  const handleClickClose = () => {
    setOpenform(false);
  };

  const getCustomerDomain = () => {
    //;
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + "BlacklistDomain";
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setSearchText("");
          res.data.forEach((d) => {
            d.date_Added = moment(d.date_Added).format('DD/MM/YYYY');
          })
          // console.log(res.data);
          setRegisteredUsers(res.data);
          //onDownloadPic(res.data[0].attachmentId);  
          setLoadedRegisteredUsers(res.data);


        } else {
          dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        ToastError(error.response.data.message);
        dispatch({ type: LOADING, payload: false });
      });
  }

  useEffect(() => {
    getCustomerDomain();
  }, []);

  const onEditUserDetails = (obj) => {
    //
    history.push("/dashboard/Editblacklistcustomerdomain/" + obj.domainName + "/" + obj.id + "/" + obj.status);
  }
  const matchRuleShort = (str, rule) => {
    var escapeRegex = (str) => str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    //const lowerCased = str.toLowerCase();
    return new RegExp("^" + rule.split("*").map(escapeRegex).join(".*") + "$", "i").test(str);
  }
  const filterGrid = () => {
    ;
    ////console.log("loadedRegisteredUsers.....",loadedRegisteredUsers); 
    ////console.log("searchedRegisteredUsers......", registeredUsers);
    //const rgUser = registeredUsers.filter(() => { return true; });
    const rgUser = loadedRegisteredUsers.filter(() => { return true; });

    setRegisteredUsers(rgUser.filter((item) => {
      return matchRuleShort(item.domainName, "*" + searchText + "*") || matchRuleShort(item.customerName, "*" + searchText + "*")
    }));

  }


  const columns = [
    {
      name: "domainName",
      label: "Domain Name",
      options: {
        filter: true,
        sort: true,

      }
    },

    {
      name: "date_Added",
      label: "Date Added",
      options: {

        filter: true,
        sort: true,
        // filterOptions: {

        //   renderValue: (value) => {
        //     return <Moment format="DD/MM/YYYY">{value}</Moment>
        //   }
        // },
        // customBodyRender: (value) => {

        //   return <Moment format="DD/MM/YYYY">{value}</Moment>


        // }
      }

    },


    {
      name: "added_By",
      label: "Created by",
      options: {
        filter: true,
        sort: true,
        // download: false,
      }
    },

    {
      name: "Created by",
      label: "Actions",
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (Value, tableMeta) => {
          return <button className={classes.link} onClick={() => { onEditUserDetails(registeredUsers[tableMeta.rowIndex]) }}>Edit </button>
        }
      }
    },

    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
      }
    },

  ]

  const options = {
    responsive: 'standard',
    filterType: 'multiselect',
    rowsPerPageOptions: [10, 15, 50, 100],
    selectableRows: false,
   
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true
      }
    },
    // onDownload: (buildHead, buildBody, columns, data) => {
    //   //

    //   const filteredClm = () => {
    //     return columns.filter((value) => {
    //       //
    //       // if (value.label == 'Actions') { delete value.label }
    //       // console.log('label', value.label)
    //       // return value.label
    //       return value.label !== 'Actions';
    //     })

    //   }

    //   const filteredBody = () => {

    //     return data.forEach((value) => {
    //       console.log('data', value.data);
    //       return value.data
    //     })

    //   }
    //   return buildHead(filteredClm()) + buildBody(filteredBody());
    // }
  };

  return (
    <div>
      <Box className="reportstablehead" component="main" mx={3} mt={3}>
        <Box className={classes.boxLayout}>
          <Box
            display="dlock"
            bgcolor="#1a1a31"
            className={classes.breadcrumbBox}
          >
            <BreadcrumbPage rows={BreadcrumbList} icon={<Help onClick={handleClickOpenForm} />} />
          </Box>
          <div>
            <Box component="div" className="pos_relative">


              {/*<Button onChange={handleClickOpen}/>*/}

              <Dialog
                open={openform}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
              >
                <DialogTitle id="scroll-dialog-title" color="white">Blacklist Domain</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                  <DialogContentText
                    id="scroll-dialog-description"
                    //ref={descriptionElementRef}
                    tabIndex={-1}
                  >
                    <p className="subtitle">Help On Blacklist Domain</p><br />
                    <img className="maxwidth100" src="/assets/images/Blacklist_domain_help_section1.jpg"></img><br /><br />
                    <p>
                      <li>Type the domain name in search box<img src={Type} alt="" width="150px" height="150px" /> and click the search button<img src={Searchbutton} alt="" width="70px" height="70px" /> will display the particular domain</li>
                      <div className={classes.text}>name</div><br />
                      <li>Click the clear button<img src={Clearbutton} alt="" width="70px" height="70px" /> will clear the searched details</li><br />
                      <li>Click the Add Domain<img src={AddDomain} alt="" width="90px" height="90px" /> will add the new domain name</li><br />
                      <li>Click the edit button will edit the domain name</li><br />
                      <li>Click the status will display the domain active or inactive</li>
                    </p>

                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClickClose}>Close</Button>
                </DialogActions>
              </Dialog>
            </Box>
          </div>
          <Box
            display="flex"
            className={classesCommonCss.justifyContentBetween}
            alignItems="center"
            px={3}
            pt={3}
            pb={5}
          >
            {/* <Box width={0.8}>
              <Box display="flex" alignItems="center"> */}
            {/* <Box component="span" fontSize="16px">
                  {"Search"}
                </Box> */}
            {/* <Box component="span" ml={2} width="260px">
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="search"
                    className={classes.txtInput}
                    placeholder="Type"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  // onChange={(e) => setPass(e.target.value)}
                  />
                </Box> */}
            {/* <Box component="span" ml={2} width="auto">
                  <Button
                    className={classes.btnStyle1}
                    onClick={(e) => filterGrid()}
                  >Search</Button>
                </Box> */}
            {/* <Box component="span" ml={3} width="260px" style={{ marginLeft: 10 }} >
                  <Button
                    className={classes.btnStyle1}
                    onClick={() => getCustomerDomain()}
                  >Clear</Button>
                </Box> */}

            {/* </Box>
            </Box> */}
            <Box>
              <Button
                className={classes.btnStyle1}
                onClick={() => {
                  history.push("/dashboard/blackcustomerusers");
                }}
              >
                Add Domain
              </Button>
            </Box>
          </Box>
          <Box className={classes.root} pb={5} px={1}>
            <TableContainer component={Paper} className={classes.tableLayout}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                      title={"BlackList Domain"}
                      className={classes.tableBody}
                      data={registeredUsers}

                      columns={columns}
                      options={options}

                    />
                    {/* <Confirmation open={openAlert} onClose={handleClose} onHandleSubmit={onAlertSubmit} BMhistorydata={Bunkermasterhistory} /> */}
                  </ThemeProvider>
                  {/* <TableRow>

                    <StyledTableCell>Domain Name</StyledTableCell>
                    <StyledTableCell>Date Added</StyledTableCell>
                    <StyledTableCell>Created by </StyledTableCell> */}
                  {/* <StyledTableCell>Modified Date</StyledTableCell>
                    <StyledTableCell> Modified By</StyledTableCell> */}
                  {/* <StyledTableCell> Actions</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                  </TableRow> */}
                </TableHead>
                <TableBody>
                  {/*  {registeredUsers.length
                    ? registeredUsers.map((row) => (
                      <Row key={row.username} editUserDetails={onEditUserDetails} row={row} />
                    ))
                    : ""} */}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
